import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "../locales/en.json";
import frTranslation from "../locales/fr.json";
import esTranslation from "../locales/es.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  es: {
    translation: esTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ['en', 'fr', 'es'], // Only allow these languages
    load: 'languageOnly', // Ignore region codes like en-GB
    interpolation: {
      escapeValue: false,
    },
    debug: false,
    parseMissingKeyHandler: function (key) {
      return key.split('.').pop();
    }
  });

// Save language preference to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;